define(['./EditAdditionalInfo', './AdditionalInfo'], (editAdditionalInfo, additionalInfo) =>
    (tileModel) => {
        let state = undefined;

        const dto = tileModel.viewModel;

        function toEdit() {
            state = {
                'id': 'edit',
                'data': editAdditionalInfo({
                    dto,
                    onQuote() {
                        toQuote();
                    },
                    markComplete() {
                        toInfo();
                    },
                    tileModel
                })
            };
        }

        function toInfo() {
            state = {
                'id': 'complete',
                'data': additionalInfo({
                    dto,
                    isEditable: () => !tileModel.isLocked,
                    onEdit: toEdit
                })
            };
        }

        function toQuote() {
            state = {
                'id': 'attemptingQuote',
                'data': additionalInfo({
                    dto,
                    isEditable: () => !tileModel.isLocked,
                    onEdit: toEdit
                })
            };
        }

        toEdit();

        return {
            get state() {
                return state;
            },
            get isComplete() {
                return state.id === 'complete' || state.id === 'attemptingQuote';
            }
        };
    }
);


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/quickquote/pa/tiles/additional/models/AdditionalTile.js
 **/